export default __webpack_public_path__ + "static/media/proximo.3afb41e5.svg";